import React from 'react';

const Footer = () => {
  return (
    <footer className="relative bg-dark-900">
      <div className="container mx-auto px-4 py-8 relative z-10">
        <div className="text-center">
          <img
            src="/logo/mapu-logo-white.png"
            alt="Mapu Logo"
            className="h-12 mx-auto mb-6"
          />
          
          <div className="border-t border-white/10 pt-6">
            <p className="text-gray-400">
              © {new Date().getFullYear()} מאפו. כל הזכויות שמורות.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 